/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import draftApi from '../../../api/draft.api';
import { createFOAsyncThunk } from '../../helpers/thunk.helpers';
import { getDashboardStatuses, SubmissionStatus } from '../../../models/SubmissionStatus';

/* Thunks */

export const fetchProcedureData = createFOAsyncThunk(
  'dashboard/fetchProcedureData',
  async ({ procedureId, subsequentActionsLabel }) => {
    const procedureData = await draftApi.getSubmissionDashboardInfo(
      procedureId,
      subsequentActionsLabel,
      getDashboardStatuses(),
    );

    return {
      procedureId,
      procedureData: procedureData.map((data) => {
        if (data.statusName === SubmissionStatus.READY_TO_SEND.id) {
          return {
            ...data,
            statusName: 'READY_TO_SEND',
          };
        }
        return data;
      }),
    };
  },
);
